import React, { useCallback, useEffect, useRef, useState } from 'react';
import { demoSources } from '../../utils/demoMedia';

const Demo = ({ sources, alt, style, className, onClick, onError }) => {
  const [videoFailed, setVideoFailed] = useState(false);
  const [posterFailed, setPosterFailed] = useState(false);
  const videoRef = useRef(null);
  const showVideo = sources.video && !videoFailed;

  const play = useCallback(() => {
    try {
      // Autoplay refusal is normal in low-power mode; a tap can retry.
      const attempt = videoRef.current?.play();
      attempt?.catch(() => {});
    } catch (_) { /* Keep the poster if the browser refuses playback. */ }
  }, []);

  useEffect(() => {
    if (showVideo) play();
  }, [play, showVideo]);

  useEffect(() => {
    if (!showVideo || !sources.poster) return;
    // Poster failures do not consistently dispatch an error on the video.
    const poster = new Image();
    poster.onerror = () => setPosterFailed(true);
    poster.src = sources.poster;
    return () => { poster.onerror = null; };
  }, [showVideo, sources.poster]);

  if (!sources.gif) return null;
  if (!showVideo) {
    return <img src={sources.gif} alt={alt} style={style} className={className} onClick={onClick} onError={onError} />;
  }
  return (
    <video
      ref={videoRef}
      src={sources.video}
      aria-label={alt}
      autoPlay
      loop
      muted
      playsInline
      poster={posterFailed ? undefined : sources.poster}
      preload="metadata"
      style={style}
      className={className}
      onClick={(event) => { play(); onClick?.(event); }}
      onError={() => setVideoFailed(true)}
    />
  );
};

const ExerciseDemo = ({ gifUrl, ...props }) => (
  <Demo key={gifUrl || ''} sources={demoSources(gifUrl)} {...props} />
);

export default ExerciseDemo;
